import React from 'react';
import { Layers } from 'lucide-react';

/** Pantalla Micelio entre login exitoso y Studio/onboarding. */
export function PostAuthLoadingScreen({
  label = 'Abriendo Studio…',
}: {
  label?: string;
}) {
  return (
    <div
      className="sala-post-auth"
      data-studio-surface="micelio"
      data-sala-theme="light"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="sala-post-auth__ambient" aria-hidden />
      <div className="sala-post-auth__card">
        <span className="sala-post-auth__mark" aria-hidden>
          <Layers className="h-5 w-5" strokeWidth={2.25} />
        </span>
        <p className="sala-post-auth__brand">Sala</p>
        <p className="sala-post-auth__label">{label}</p>
        <div className="sala-post-auth__pulse" aria-hidden />
      </div>
    </div>
  );
}
